module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-02.3ed2afa6.png";